export const rolesToOmit = ["customer"];
export const rolesLimitation = ["agent"];

export const roleDisabledCheck = (name: string) =>
  rolesToOmit.includes(name.toLocaleLowerCase());

export const roleLimitationDisabledCheck = (name: string) =>
  !rolesLimitation.includes(name.toLocaleLowerCase());
